import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { withLatestFrom, map, filter, exhaustMap, catchError, share } from 'rxjs/operators';
import { SettingsService } from '../../services/settings/settings.service';
import { HttpService } from '../../services/http/http.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../interfaces/app-state.interface';
import { PlatformsAcceptanceAction } from './platforms-acceptance.action';
import { HttpHeaders } from '@angular/common/http';
import { UsersState } from '../users/users.reducer';

@Injectable()
export class PlatformsAcceptanceEffects {

    @Effect()
    public getDataTransferAcceptance$: Observable<any> = this.actions$
        .pipe(
            ofType(PlatformsAcceptanceAction.getDataTransferAcceptance),
            withLatestFrom(this.store$.select((s) => s.authentication)),
            filter(([action, auth]) => auth.currentUser && auth.currentUser.token),
            exhaustMap(([action, auth]) => {
                const awsUrl = this.settingsService.getConfigurationKeyValue(
                  "backend"
                );
                const isLogged = !!(auth.currentUser && auth.currentUser.token);
                return this.httpService.get<any>(`${awsUrl.api}/agreement/platforms/dataTransferAcceptance?platform=${action.payload}`, this.createHeaders(auth, isLogged))
                    .pipe(
                        map((result: any) => {
                            if (result) {
                                return { type: PlatformsAcceptanceAction.getDataTransferAcceptanceSuccess, payload: result };
                            }
                            return { type: PlatformsAcceptanceAction.getDataTransferAcceptanceError, payload: result };
                        }),
                        catchError((error) => {
                            return of({ type: PlatformsAcceptanceAction.getDataTransferAcceptanceError, payload: error });
                        }),
                    )
                },
            ),
            share());

    @Effect()
    public setDataTransferAcceptance$: Observable<any> = this.actions$
        .pipe(
            ofType(PlatformsAcceptanceAction.setDataTransferAcceptance),
            withLatestFrom(this.store$.select((s) => s.authentication)),
            filter(([action, auth]) => auth.currentUser && auth.currentUser.token),
            exhaustMap(([action, auth]) => {
                const awsUrl = this.settingsService.getConfigurationKeyValue(
                    "backend"
                );
                const isLogged = !!(auth.currentUser && auth.currentUser.token);
                const payload = { platform: action.payload }
                return this.httpService.post<any>(`${awsUrl.api}/agreement/platforms/dataTransferAcceptance`, payload, this.createHeaders(auth, isLogged))
                    .pipe(
                        map((result: any) => {
                            if (result) {
                                return { type: PlatformsAcceptanceAction.getDataTransferAcceptanceSuccess, payload: result };
                            }
                            return { type: PlatformsAcceptanceAction.getDataTransferAcceptanceError, payload: result };
                        }),
                        catchError((error) => {
                            return of({ type: PlatformsAcceptanceAction.getDataTransferAcceptanceError, payload: error });
                        }),
                    )
                },
            ),
            share());

    constructor(
        private actions$: Actions<PlatformsAcceptanceAction>,
        private store$: Store<AppState>,
        private settingsService: SettingsService,
        private httpService: HttpService,
        ) { }

    private createHeaders(userData: UsersState, logged: boolean = false) {
        if (!logged) {
            return new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'X-SessionID': `${userData.sessionID}`,
            });
        } else {
            return new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${userData.currentUser.token}`,
            });
        }
    }
}
